import { __moduleExports as Draggable_1 } from './Draggable.js';

var Draggable = Draggable_1.default,
    DraggableCore = Draggable_1.DraggableCore; // Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266


var cjs = Draggable;
var default_1 = Draggable;
var DraggableCore_1 = DraggableCore;
cjs.default = default_1;
cjs.DraggableCore = DraggableCore_1;

export { DraggableCore_1 as DraggableCore, cjs as __moduleExports, cjs as default };
